(function () {
    if (window.__stbMenuInit) return;
    window.__stbMenuInit = true;

    /* Move the STB menu (from sections/stb-menu.liquid) into Horizon's mobile drawer. */
    function inject() {
      var tpl = document.getElementById('StbMenuTemplate');
      if (!tpl) return;
      document.querySelectorAll('header-drawer .menu-drawer').forEach(function (drawer) {
        if (drawer.querySelector(':scope > .stb-menu')) return;
        drawer.prepend(tpl.content.cloneNode(true));
        drawer.classList.add('menu-drawer--stb');
      });
    }

    /* Desktop: keep Horizon's header in "drawer" mode (burger) when the section asks for it. */
    function forceDrawer() {
      if (!window.__stbDesktopDrawer) return;
      var h = document.getElementById('header-component');
      if (!h) return;
      if (h.getAttribute('data-menu-style') !== 'drawer') h.setAttribute('data-menu-style', 'drawer');
      if (!h.__stbWatch) {
        h.__stbWatch = true;
        new MutationObserver(forceDrawer).observe(h, { attributes: true, attributeFilter: ['data-menu-style'] });
      }
    }

    /* Own close button: use the drawer's own close() so focus trap and animation stay intact. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-stb-close]');
      if (!btn) return;
      e.preventDefault();
      var hd = btn.closest('header-drawer');
      if (hd && typeof hd.close === 'function') { hd.close(); return; }
      var d = btn.closest('details');
      if (d) { d.classList.remove('menu-open'); d.removeAttribute('open'); }
    });

    /* 29.09.2026: swatch photos are preloaded (menu opened / swatch hovered or touched) and
       swapped only once decoded (max. 700 ms), so a colour click never shows a blank photo. */
    var stbImgCache = {};
    function stbPreload(src) {
      if (!src) return null;
      if (!stbImgCache[src]) {
        var im = new Image();
        im.__ready = new Promise(function (r) { im.onload = r; im.onerror = r; });
        im.src = src;
        stbImgCache[src] = im;
      }
      return stbImgCache[src];
    }
    function stbSwapImg(img, src) {
      var token = (img.__stbSwap = (img.__stbSwap || 0) + 1);
      var im = stbPreload(src);
      var done = function () {
        if (img.__stbSwap !== token) return;
        img.removeAttribute('srcset');
        img.src = src;
      };
      if (!im || (im.complete && im.naturalWidth)) { done(); return; }
      Promise.race([im.__ready, new Promise(function (r) { setTimeout(r, 700); })]).then(done);
    }
    function stbPreloadSwatch(sw) {
      if (!sw) return;
      stbPreload(sw.dataset.src);
      [].slice.call(sw.attributes).forEach(function (a) { if (a.name.indexOf('data-follow-') === 0) stbPreload(a.value); });
    }
    function stbPreloadCardSwatches(root) {
      (root || document).querySelectorAll('[data-stb-swatch]').forEach(stbPreloadSwatch);
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        stbPreloadSwatch(t.closest('[data-stb-swatch]'));
      }, { passive: true });
    });
    // When a menu opens, warm all its swatch photos in the background.
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d instanceof HTMLDetailsElement && d.open && d.querySelector('[data-stb-swatch]')) {
        (window.requestIdleCallback || setTimeout)(function () { stbPreloadCardSwatches(d); });
      }
    }, true);

    /* Colour swatches: swap photo, colour name and link of the card.
       The "Complete the bed" tiles ([data-stb-follow="1|2"]) follow the duvet colour. */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-stb-swatch]');
      if (!sw) return;
      e.preventDefault();
      var card = sw.closest('[data-stb-card]');
      if (!card) return;
      card.querySelectorAll('[data-stb-swatch]').forEach(function (b) {
        b.classList.toggle('is-active', b === sw);
        b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
      });
      var img = card.querySelector('[data-stb-img]');
      if (img && sw.dataset.src) {
        stbSwapImg(img, sw.dataset.src);
        img.alt = img.alt.replace(/–.*$/, '– ' + sw.dataset.name);
      }
      var name = card.querySelector('[data-stb-colour-name]');
      if (name) name.textContent = sw.dataset.name;
      var link = card.querySelector('[data-stb-link]');
      if (link && sw.dataset.href) link.href = sw.dataset.href;
      var menu = card.closest('[data-stb-menu]');
      if (menu) {
        menu.querySelectorAll('[data-stb-follow]').forEach(function (fi) {
          var src = sw.getAttribute('data-follow-' + fi.getAttribute('data-stb-follow'));
          if (src) stbSwapImg(fi, src);
        });
      }
    });

    /* Sleep Finder */
    var WHOS = [
      { id: 'me', label: 'Just me', sub: 'My own bed' },
      { id: 'us', label: 'Me and my partner', sub: 'One shared bed' },
      { id: 'child', label: 'My child', sub: 'Kids’ bed' },
      { id: 'gift', label: 'Someone else', sub: 'It’s a gift' }
    ];
    var LABELS = {
      cover: 'Wrestling with the duvet cover',
      kids: 'Accidents and sick bugs at night',
      dog: 'The dog sleeps on the bed',
      temp: 'Too hot, then too cold',
      twoperson: 'Changing covers is a two-person job now',
      rarely: 'Honestly? It rarely gets washed'
    };
    var GIFT_LABELS = {
      cover: 'They hate changing the cover',
      twoperson: 'Changing covers has got hard for them',
      dog: 'Their dog sleeps on the bed',
      temp: 'They sleep too hot or too cold'
    };
    var SETS = {
      me: ['cover', 'temp', 'dog', 'rarely'],
      us: ['cover', 'temp', 'dog', 'twoperson'],
      child: ['kids', 'cover', 'dog', 'temp'],
      gift: ['cover', 'twoperson', 'dog', 'temp']
    };
    var COPY = {
      cover: { h: 'No cover. Nothing to wrestle.', b: 'Take it off the bed and wash the whole thing. It goes back on in seconds.', qty: 1, up: 'sheet' },
      kids: { h: 'At 3am, it’s one thing to wash, not two.', b: 'Strip it, wash it, done. Most parents keep two, so a fresh one is always ready.', qty: 2, up: 'two' },
      dog: { h: 'The dog can stay.', b: 'Skip the towel on top. Hair, paws and muddy walks go in the wash with the whole duvet.', qty: 2, up: 'two' },
      temp: { h: 'Cosy in winter, easy all year.', b: 'It’s 10.5 tog, the usual all-year weight in the UK. For hot summer nights, our cooling blanket is on its way.', qty: 1, up: 'cooling' },
      twoperson: { h: 'There’s nothing to put on.', b: 'No cover, no buttons, no shaking it out. One item goes on the bed.', qty: 1, up: 'pillow' },
      rarely: { h: 'Made so washing it is easy.', b: 'One item, one wash, straight back on the bed. No cover to take off first.', qty: 1, up: 'sheet' }
    };

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    var PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F7B39D" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

    function readData(finder) {
      var el = finder.parentElement.querySelector('[data-stb-finder-data]');
      try { return JSON.parse(el.textContent); } catch (err) { console.warn('[stb-menu] finder data', err); return null; }
    }

    function currentDuvetColour(finder) {
      var menu = finder.closest('[data-stb-menu]');
      var active = menu && menu.querySelector('[data-stb-card] [data-stb-swatch].is-active');
      return active ? active.dataset.name : null;
    }

    function render(finder) {
      var st = finder.__stb;
      var data = st.data;
      var stage = finder.querySelector('[data-stb-stage]');
      var dots = finder.querySelectorAll('[data-stb-dots] i');
      var cur = Math.min(st.step, 2);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-on', st.step === 3 || i <= cur);
        d.classList.toggle('is-current', st.step < 3 && i === cur);
      });
      var html = '';
      if (st.step === 0) {
        html += '<p class="stb-finder__q">Who is the duvet for?</p><div class="stb-finder__grid">';
        WHOS.forEach(function (w) {
          html += '<button type="button" class="stb-finder__opt" data-stb-act="who" data-v="' + w.id + '"><span>' + esc(w.label) + '</span><small>' + esc(w.sub) + '</small></button>';
        });
        html += '</div>';
      } else if (st.step === 1) {
        var q2 = st.who === 'gift' ? 'What would make their nights easier?' : (st.who === 'child' ? 'What happens most at night?' : 'What gets in the way of a good night?');
        html += '<p class="stb-finder__q">' + q2 + '</p><div class="stb-finder__grid">';
        (SETS[st.who] || SETS.me).forEach(function (id) {
          var label = st.who === 'gift' ? GIFT_LABELS[id] : LABELS[id];
          html += '<button type="button" class="stb-finder__opt stb-finder__opt--tall" data-stb-act="problem" data-v="' + id + '">' + esc(label) + '</button>';
        });
        html += '</div><button type="button" class="stb-finder__link" data-stb-act="back">Back</button>';
      } else if (st.step === 2) {
        html += '<p class="stb-finder__q">' + (st.who === 'gift' ? 'What size is their bed?' : 'What size is the bed?') + '</p><div class="stb-finder__grid">';
        data.sizes.forEach(function (s) {
          html += '<button type="button" class="stb-finder__opt" data-stb-act="size" data-v="' + esc(s.value) + '"><span>' + esc(s.name) + '</span><small>' + esc(s.dims) + '</small></button>';
        });
        var dbl = data.sizes[1] ? data.sizes[1] : data.sizes[0];
        html += '<button type="button" class="stb-finder__opt stb-finder__opt--dashed" data-stb-act="size" data-v="' + esc(dbl.value) + '"><span>Not sure</span><small>We’ll suggest ' + esc(dbl.name) + '</small></button>';
        html += '</div><button type="button" class="stb-finder__link" data-stb-act="back">Back</button>';
      } else {
        var c = COPY[st.problem] || COPY.cover;
        var head = c.h, body = c.b, cta = c.qty === 2 ? 'Shop 2 duvets' : 'Shop my duvet';
        if (st.who === 'gift') {
          head = 'A gift they’ll use every night.';
          body = c.b + ' Wrong size? They can swap it for free.';
          cta = 'Shop the gift';
        }
        var size = data.sizes.filter(function (s) { return s.value === st.size; })[0] || data.sizes[0];
        var colour = currentDuvetColour(finder);
        var variant = data.variants.filter(function (v) { return v.size === st.size && (!colour || v.colour === colour); })[0]
          || data.variants.filter(function (v) { return v.size === st.size; })[0];
        var href = variant ? variant.url : data.duvetUrl;
        var title = (c.qty === 2 ? '2 × One-Piece Duvet · ' : 'One-Piece Duvet · ') + size.name;
        var price = c.qty === 2 ? '' : (variant ? variant.price : '');
        var incl = c.qty === 2 ? 'Extra 10% off both · 4 pillowcases + storage bag free' : '2 matching pillowcases included free';
        var up = '';
        if (c.up === 'sheet') up = '<a href="' + esc(data.sheetUrl) + '">Add a matching fitted sheet</a> so the whole bed washes together.';
        if (c.up === 'two') up = 'One on the bed, one in the wash. Two duvets: an extra 10% off both, plus 4 pillowcases and a storage bag free.';
        if (c.up === 'pillow') up = '<a href="' + esc(data.pillowUrl) + '">Add extra matching pillowcases</a>.';
        if (c.up === 'cooling') up = data.coolingUrl
          ? '<a href="' + esc(data.coolingUrl) + '">Join the Cooling Blanket list</a> and hear first when it launches.'
          : '<a href="' + esc(data.sheetUrl) + '">Add a matching fitted sheet</a> so the whole bed washes together.';
        html += '<p class="stb-finder__q">' + esc(head) + '</p><p class="stb-finder__body">' + esc(body) + '</p>';
        html += '<div class="stb-finder__match"><span class="stb-finder__match-label">Your match</span><div class="stb-finder__match-row"><span class="stb-finder__match-title">' + esc(title) + '</span>' + (price ? '<span class="stb-finder__match-price">' + esc(price) + '</span>' : '') + '</div><span class="stb-finder__match-incl">' + esc(incl) + '</span></div>';
        html += '<div class="stb-finder__upsell">' + PLUS + '<span>' + up + '</span></div>';
        html += '<a class="stb-finder__cta" href="' + esc(href) + '">' + esc(cta) + '</a>';
        html += '<button type="button" class="stb-finder__link stb-finder__link--center" data-stb-act="restart">Start again</button>';
      }
      stage.innerHTML = html;
    }

    function init(finder) {
      if (finder.__stb) return;
      var data = readData(finder);
      if (!data || !data.sizes || !data.sizes.length) return;
      finder.__stb = { step: 0, who: null, problem: null, size: null, data: data };
      render(finder);
    }

    function initAll() { forceDrawer(); inject(); document.querySelectorAll('header-drawer [data-stb-finder]').forEach(init); }
    /* 05.10.2026 (speed): the menu is no longer built while the page is loading, and it no
       longer re-checks the whole page on every small change anywhere on it. It is built at
       the visitor's first touch / click / key press, or shortly after the page has finished
       loading, and afterwards only watches the header itself. */
    var stbBuilt = false, stbPending = false;
    function stbBuild() {
      if (stbBuilt) return;
      stbBuilt = true;
      initAll();
      var root = document.getElementById('header-group') || document.getElementById('header-component');
      if (!root) return;
      new MutationObserver(function () {
        if (stbPending) return;
        stbPending = true;
        requestAnimationFrame(function () { stbPending = false; initAll(); });
      }).observe(root, { childList: true, subtree: true });
    }
    function stbStart() {
      forceDrawer();
      if (window.Shopify && window.Shopify.designMode) { stbBuild(); return; }
      ['touchstart', 'pointerdown', 'mouseover', 'keydown', 'focusin'].forEach(function (ev) {
        window.addEventListener(ev, stbBuild, { once: true, passive: true, capture: true });
      });
      var later = function () {
        if (window.requestIdleCallback) window.requestIdleCallback(stbBuild, { timeout: 3000 });
        else setTimeout(stbBuild, 1500);
      };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stbStart); else stbStart();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-stb-act]');
      if (!btn) return;
      var finder = btn.closest('[data-stb-finder]');
      if (!finder || !finder.__stb) return;
      e.preventDefault();
      var st = finder.__stb, act = btn.dataset.stbAct, v = btn.dataset.v;
      if (act === 'who') { st.who = v; st.step = 1; }
      else if (act === 'problem') { st.problem = v; st.step = 2; }
      else if (act === 'size') { st.size = v; st.step = 3; }
      else if (act === 'back') { st.step = Math.max(0, st.step - 1); }
      else if (act === 'restart') { st.step = 0; st.who = null; st.problem = null; st.size = null; }
      render(finder);
    });
  })();
